import React from "react";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";
import {ManageSiteTable} from "../../UI/Main/ManageSiteTable";
import {ManageSupportTable} from "../../UI/Main/ManageSupportTable";

const ManageSupport = () => {
    return (
        <div>
            <PanelHead title="Manage Services" />
            <PanelBody content={<ManageSupportTable />} />
        </div>
    );
};

export default ManageSupport;
